const topics = [
  { label: '鬼灭之刃', count: '128万', hot: true },
  { label: '咒术回战', count: '115万', hot: true },
  { label: '葬送的芙莉莲', count: '98万', hot: true },
  { label: '我推的孩子', count: '87万', hot: false },
  { label: '怪兽8号', count: '76万', hot: true },
  { label: '防风少年', count: '65万', hot: false },
  { label: '迷宫饭', count: '58万', hot: false },
  { label: '无职转生', count: '52万', hot: false },
  { label: 'Re:从零开始', count: '49万', hot: false },
  { label: '间谍过家家', count: '44万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网最热动漫话题追踪，看看大家都在讨论什么番
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 hover:scale-105 ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/70 text-foreground-700 hover:border-foreground-300'
              }`}
            >
              {topic.hot && (
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-fire-fill text-xs text-primary-500"></i>
                </div>
              )}
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-60 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}